<template>
    <div id="user_page">

    <section class="hero">
    
    </section>

      <div class="centered_md">
            <div id="user_details_box">
                <div class="head">
                    
                    <h3>אזור אישי </h3>
                    <h4>פרטי חשבון</h4>

                    <div class="left_side">
                       <router-link to="/user/profiles/disconect" v-if="user.cancel_sub == '0'">
                       ביטול מנוי
                         </router-link>
                        <a v-if="user.cancel_sub == '1'" @click="resubscribe()">חידוש מנוי</a>
                        <a @click="logout()">יציאה מהחשבון</a>
                    </div>
                  <!--  <div class="background">
                          <form action="post" id="why_left">
                            <p>נשמח אם תוכל/י לציין בכמה מילים למה את/ה רוצים לעזוב את השירות  </p>
                            <textarea></textarea>

                          </form> 
                    </div>-->
                </div>
                <div class="inner">
                    <div class="line">
                      <form @submit.prevent="save_details()">
                        <ul>
                            <li><label>בעל החשבון</label><span v-if="edit_dets !== true" v-text="user.display_name"></span><input v-else type="text" v-model="user.display_name"></li>
                            <li><label>טלפון</label><span v-if="edit_dets !== true" v-text="user.phone"></span><input v-else type="text" v-model="user.phone"></li>
                            <li>
                              <label>כתובת מייל</label><span v-if="edit_dets !== true" v-text="user.username">ישראל</span><input v-else type="email" required v-model="user.username">
                              <input style="margin-right:15px" v-if="edit_dets == true" type="submit" value="שמירה" >
                            </li>
                            
                        </ul>
                      </form>
                        <a class="edit" @click="edit_dets = !edit_dets">עריכת פרטים</a>
                    </div>
                    
                    <div class="line">
                        <ul>
                            <li><label>סיסמה</label><span v-if="edit_pass !== true">****</span><input v-else type="password" v-model="new_password"><input style="margin-right:15px" v-if="edit_pass == true" type="submit" value="שמירה" @click="save_pass()"></li>
                        </ul>
                        <a class="edit" @click="edit_pass = !edit_pass">עריכת סיסמא</a>
                    </div>
                    
                    <div class="line">
                        <ul>
                            <li><label>אמצעי תשלום</label><span>ישראל</span></li>
                            <li><span>VISA **********1234</span></li>
                        </ul>
                        <a class="edit">החלפת פרטי כרטיס אשראי</a>
                    </div>

                </div>
            </div>
<!--
            <div class="row" id="menu_btns">
                <div class="col-md-4">  <a class=""><span></span> חשבונית אחרונה</a></div>
                <div class="col-md-4">  <a class=""><span></span> הסטוריית חשבוניות</a></div>
                <div class="col-md-4">  <a class=""><span></span> ניהול פרופילים</a></div>
            </div>
-->
            <div class="clr"></div>

           
            <div id="last_views_list">

                <h3 class="title">צפיות אחרונות</h3>

                <div v-for="item in last_views" class="item" :key="item.id">
              
                        <router-link :to="'item/' + item.id" class="pic col-md-2 col-xs-12" :style="'background-image:url(' + item.pic_thumb_parsed + ')'">
                                <div class="user_duration"><span :style="'width:' + item.user_duration_perc + '%'"></span></div>
                         </router-link>
                        <div class="details col-md-4"  > 
                            <router-link :to="'item/' + item.id"><h3>{{ item.title }}</h3>
                             <label> {{ item.type }}</label> 
                             </router-link>
                        </div>
                        <label class="col-md-2"  v-if="!is_mobile()"></label>
                        <label class="col-md-2"  v-if="!is_mobile()">{{ item.key_date }}</label>
                        <div class="col-md-2"><router-link :to="'item/' + item.id" class="btn_view"><!--<span></span>--> לצפייה</router-link></div>
                   

                </div>
            </div>

      </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
      last_views: [],
      user: {},
      edit_dets: false,
      edit_pass: false,
      new_password: '',
    };
  },
  methods: {
    
    logout(){
      localStorage.removeItem('user_token');
      document.location = '/';
    },
    reason_left(){
       
      this.background = !this.background
    },
    
    save_details(){

      if (this.user.display_name == '') { alert('יש למלא את כל הפרטים'); return false; }
      if (this.user.phone == '') { alert('יש למלא את כל הפרטים'); return false; }
      if (this.user.username == '') { alert('יש למלא את כל הפרטים'); return false; }
      
      this.api_call({ url: 'update_user_details', data: this.user, onComplete: (data) => {
        if(data.data.data === 'email_in_use')
        {
          alert('אופס..כתובת המייל הזאת תפוסה כבר :)');
          return false;
        }
        else{
          alert('המידע נשמר בהצלחה!');
          this.edit_dets = false;
        }
        

      } } );

    },
    save_pass(){

      if (this.new_password == '') { alert('יש להזין סיסמה חדשה'); return false; }

      this.api_call({ url: 'update_user_details', data: { password: this.new_password }, onComplete: function(data){

        self.last_views = data.data.data.items;

      } } );

    },

    unsubscribe(){
      var self = this;

      if (confirm('האם אתה בטוח שברצונך לבטל את המנוי?'))
      {
        this.api_call({ url: 'user/cancel_subscription', onComplete: function(){

          alert('המנוי בוטל');

          self.api_call({ url: 'general', onComplete: function(data){


            self.user = data.data.data.user;

          } } );

          //self.last_views = data.data.data.items;

        } } );
      }
    },

    resubscribe(){
      var self = this;

      if (confirm('האם אתה בטוח שברצונך לחדש את המנוי?'))
      {
        this.api_call({ url: 'user/renew_subscription', onComplete: function(){

          alert('המנוי חודש');

          self.api_call({ url: 'general', onComplete: function(data){


            self.user = data.data.data.user;

          } } );

          //self.last_views = data.data.data.items;

        } } );
      }
    }

  },
  created() {

      var self = this;
  
      this.api_call({ url: 'items/results', data: { user_history: true }, onComplete: function(data){

        self.last_views = data.data.data.items;

      } } );

    this.api_call({ url: 'general', onComplete: function(data){


      self.user = data.data.data.user;

    } } );

    
  }
}
</script>
